import React from 'react';
import { useState } from 'react';
import RenewClubDetails from './RenewClubDetails';
import RenewGolfCourses from './RenewGolfCourses';
import RenewPayment from './RenewPayment';
import RenewPayConfirmed from './RenewPayConfirmed';


const RenewMembership = () => {
    const [ScreenPostion, SetScreenPostion] = useState(1);
    const [users, Setusers] = useState('');
    const [reference_id, Setreference_id] = useState('');

    // useEffect(() => {
    //     project();
    // }, [ScreenPostion]);

    return (
        <>
            { 
                (ScreenPostion === 1 && <RenewClubDetails      SetScreenPostion={SetScreenPostion}     />) 
                || (ScreenPostion === 2 && <RenewGolfCourses      SetScreenPostion={SetScreenPostion}  Setusers={Setusers}   />) 
                || (ScreenPostion === 3 && <RenewPayment      SetScreenPostion={SetScreenPostion}  users={users} Setreference_id={Setreference_id}  />) 
                || (ScreenPostion === 4 && <RenewPayConfirmed      SetScreenPostion={SetScreenPostion}  reference_id={reference_id}    />) 
                || <h1>Something Else</h1> 
            }
        </>
    )
}

export default RenewMembership;
